import { tscope } from '@i18n/index';

export const ts = tscope('Documents.missingDocumentModal');
